// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCQ6n9D6FPyo53-3aVqc2ve2WDnRkFPpTY",
    authDomain: "charlotte-7a661.firebaseapp.com",
    projectId: "charlotte-7a661",
    storageBucket: "charlotte-7a661.firebasestorage.app",
    messagingSenderId: "1096235196582",
    appId: "1:1096235196582:web:ff4bcf57f89e1c30bf9467",
    measurementId: "G-1B2NE6D9RR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
export { auth, db, functions };